export const RENTALS_REQUEST = "RENTALS_REQUEST";
export const RENTALS_SUCCESS = "RENTALS_SUCCESS";
export const RENTALS_FAILURE = "RENTALS_FAILURE";

export const MONTHLY_REQUEST = "MONTHLY_REQUEST";
export const MONTHLY_SUCCESS = "MONTHLY_SUCCESS";
export const MONTHLY_FAILURE = "MONTHLY_FAILURE";
